import React from "react";
import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import Vendor from "../../Utility/Crud/Vendor";

export default class ChipVendor extends Chip {
    /**
     * Renders a MUI Avatar.
     */
    renderAvatar() {
        const color = (this.props.vendor ? Vendor.getColor() : MUIGreyColor[500]);
        const avatarColor = this.props.isTransparent ? "transparent" : color;
        const iconColor = this.props.isTransparent ? color : "#fff";

        return (
            <MUIAvatar sx={{ bgcolor: avatarColor }}>
                {Vendor.getIcon({ fontSize: "small", sx: { color: iconColor } })}
            </MUIAvatar>
        );
    }

    /**
     * @return {string} The vendor name.
     */
    getLabel() {
        return this.props.vendor ? Vendor.getDisplayName(this.props.vendor) : "None";
    }
}
